module.exports = __webpack_public_path__ + "851ffdf2eea85e68ed07563705afaac9.svg";